import React from "react";
import { ListWrapper } from "./styled";
import ListItem from "./ListItem";
import { useStructureStore } from "../store/structure-store";

function StructuredList() {
  const structure = useStructureStore((state) => state.structure);

  const directChildItems = structure?.children;
  return (
    <ListWrapper style={{ marginTop: "20px" }}>
      {directChildItems.map((node) => (
        <ListItem key={node.id} node={node} />
      ))}
    </ListWrapper>
  );
}

export default StructuredList;
